exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-industry-tsx": () => import("./../../../src/pages/industry.tsx" /* webpackChunkName: "component---src-pages-industry-tsx" */),
  "component---src-pages-insurance-tsx": () => import("./../../../src/pages/insurance.tsx" /* webpackChunkName: "component---src-pages-insurance-tsx" */)
}

